import { useHasRestoreFailed } from '../has-restore-failed';
import { useIsFormDirty, useIsModalOpen } from '../in-progress-issue';
import { useIsIssueRestoreSaving } from '../is-issue-restore-saving';
import { useNavigationBlock } from './use-navigation-block';

export const useShouldShowBrowserWarning = (): void => {
	const [isModalOpen] = useIsModalOpen();
	const [isFormDirty] = useIsFormDirty();

	const isFormSavingIssueRestore = useIsIssueRestoreSaving();
	const hasRestoreFailed = useHasRestoreFailed();

	const shouldForceBlock = isModalOpen && (hasRestoreFailed || isFormSavingIssueRestore);

	useNavigationBlock({
		forceBlock: shouldForceBlock,
		shouldAttemptNavigationBlock: Boolean(isModalOpen && isFormDirty),
	});
};
